import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';

import Box from '@mui/material/Box';

import Nav from './nav';
import Main from './main';
import Header from './header';
import SessionExpiredDialog from './SessionExpiredDialog';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const [openNav, setOpenNav] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const cookies = new Cookies();

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    const handler = (event) => {
      setMessage(event.detail.message);
      setOpen(true);
    };
    window.addEventListener('authError', handler);
    return () => window.removeEventListener('authError', handler);
  }, []);

  return (
    <>
      <Header onOpenNav={() => setOpenNav(true)} isCollapsed={isCollapsed} />
      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        <Nav
          openNav={openNav}
          onCloseNav={() => setOpenNav(false)}
          isCollapsed={isCollapsed}
          onToggleCollapse={handleToggleCollapse}
        />
        <Main isCollapsed={isCollapsed}>{children}</Main>
        <SessionExpiredDialog
          open={open}
          onLogin={() => {
            setOpen(false);
            cookies.remove('access');
            cookies.remove('refresh');
            cookies.remove('role');
            cookies.remove('username');
            cookies.remove('user');
            navigate('/login', { replace: true });
          }}
        />
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
